import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTextInputStyles = ({
  spacing,
  palette,
  borders,
  borderRadius,
  typography,
}: Theme) => {
  return {
    root: css({
      width: "100%",
      display: "flex",
      flexDirection: "column",
    }),
    wrapper: css({
      display: "flex",
      alignItems: "center",
      borderRadius: borderRadius.medium,
      outline: "none",
      border: borders.input.main,
      backgroundColor: grey[100],
      height: 50,
      "&:focus-within": {
        border: borders.input.main,
      },
    }),
    disabled: css({
      backgroundColor: palette.secondary.dark,
      pointerEvents: "none",
      cursor: "not-allowed",
    }),
    adornmentWrapper: css({
      display: "flex",
      color: grey[500],
    }),
    adornmentWrapperError: css({
      color: palette.error.textLight,
    }),
    startAdornment: css({
      paddingLeft: spacing(1.5),
    }),
    endAdornment: css({
      paddingRight: spacing(1.5),
    }),
    input: css({
      padding: spacing([2, 1]),
      border: 0,
      width: "100%",
      outline: "none",
      backgroundColor: "transparent",
      color: palette.secondary.textDark,
      fontSize: typography.fontSize.large,
      fontFamily: typography.fonts.body,
      fontWeight: typography.fontWeight.medium,
      "::placeholder": {
        color: grey[500],
        fontWeight: typography.fontWeight.medium,
      },
    }),
    error: css({
      "::placeholder": {
        color: palette.error.textDark,
      },
    }),
    wrapperRegular: css({
      "&[disabled]": {
        backgroundColor: palette.disabled.background,
      },
    }),
    wrapperError: css({
      border: borders.input.error,
      backgroundColor: palette.error.light,
    }),
  };
};
